/** @format */

import {Root, SizeType} from './styles';

interface Props {
  videoId: string;
  // Если true, то в src будет подставлен целиком videoId
  isReplaceLink?: boolean;
  size?: SizeType;
  overrideWidth?: string;
  overrideHeight?: string;
}

const RutubePlayer = ({
  videoId,
  isReplaceLink,
  size = 'small',
  overrideWidth,
  overrideHeight,
}: Props) => {
  return (
    <Root
      size={size}
      overrideWidth={overrideWidth}
      overrideHeight={overrideHeight}
      src={isReplaceLink ? videoId : `https://rutube.ru/play/embed/${videoId}`}
      allow='clipboard-write'
      allowFullScreen
    />
  );
};

export {RutubePlayer};
